document.addEventListener("DOMContentLoaded", function () {
  let viewIcons = document.querySelectorAll("[data-icon-view]");
  viewIcons.forEach((icon) => {
    icon.addEventListener("click", (e) => changeView(e));
  });
  let filtersButton = document.getElementById('ff-filters-button')
  // filtersButton.addEventListener("click", () => openFiltersDrawer())
  document.querySelector('.alohas-mobile-facets__close').addEventListener("click", () => closeFiltersDrawer())
});

function changeView(event) {
  const linkPagination = document.querySelector("#ff-paginate-link");
  let iconClicked = event.target.closest(".view-icon");
  let elementId = iconClicked.id;
  let productGrid = document.querySelector("#product-grid");
  if (linkPagination) {
    let pv = "";
    const linkObject = linkPagination.href.split("&pv");
    if (iconClicked.id == "fullscreen-grid") {
      pv = "&pv=1";
    } else if (iconClicked.id == "small-grid") {
      pv = "&pv=2";
    } else if (iconClicked.id == "card-grid") {
        pv = "&pv=3";
    }
    linkPagination.href = `${linkObject[0]}${pv}`;
  }

  document
    .querySelectorAll(".view-icon")
    .forEach((icon) => icon.classList.remove("selected"));
  iconClicked.classList.add("selected");
  productGrid.dataset.gridView = elementId;
}

function handlePriceChange(input) {
  const spanId = input.dataset.valueId
  const valueContainer = document.getElementById(spanId)
  valueContainer.innerHTML = input.value
}

function openFiltersDrawer() {
  document.querySelector('facet-filters-form').style.display = 'block'
  setTimeout(() => {
    document.querySelector('facet-filters-form').classList.add('alohas-filters-open')
  }, 300);
  document.body.classList.add('no-scroll')
}

function closeFiltersDrawer() {
  document.querySelector('facet-filters-form').classList.remove('alohas-filters-open')
  setTimeout(() => {
    document.querySelector('facet-filters-form').style.display = 'none'
  }, 300);
  document.body.classList.remove('no-scroll')
}
